<div>
  <mat-card appearance="outlined">
    <mat-card-title>Téléchargement de votre facture</mat-card-title>
    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    }
  </mat-card>
</div>
@if (errTxt && !isLoading) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Erreur</mat-card-title>
      <p>{{ errTxt }} @if (showLink) {
        <span><a href="https://moncompte.inextenso.fr/login">In Extenso Mon Compte</a></span>
      }</p>
    </mat-card>
  </div>
}
